import React, { useState, useEffect, useRef } from 'react'
import { useParams } from 'react-router-dom';
import { Alerts, GetOrders } from '../../../helpers';
import { FaPrint } from "react-icons/fa";
import { MdOutlineCancel, MdLocationPin  } from "react-icons/md";
import { FiChevronLeft } from "react-icons/fi";
import { Card } from 'react-bootstrap';
import OrderNote from '../../../components/order/OrderNote';
import { Link } from 'react-router-dom';
import { useReactToPrint } from "react-to-print";
import parse from 'html-react-parser';
import ThemeModal from '../../../components/cmp/ThemeModal';
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import Dropdown from 'react-bootstrap/Dropdown';
import { TbAntennaBars1, TbTruckDelivery } from "react-icons/tb";
import ConfModal from '../../../components/cmp/ConfModal';
import {formatDate, getDateTime} from '../../../utils/DateFormat';
import { FaCircle, FaPhotoVideo, FaHeart } from "react-icons/fa";
import { orderStatusMap, paymentStatusMap } from '../../../utils/statusFormat';
const SingleOrder = () => {

    const [isLoading, setLoading] = useState(true);
    const [order, setOrder] = useState(null);
    const { orderid } = useParams();
    const [invoiceLoading, setInvoiceLoading] = useState(false);
    const [isOrderProcess, setOrderProcess] = useState(false);
    const [isCancel, setCancel] = useState(false);
    const [groupedItems, setGroupedItems] = useState([]);



    const contentRef = useRef(null);
    const getOrder = async (orderid) => {
        const resp = await GetOrders.getSingleOrders(orderid);
        console.log('resp', resp);

        if (resp && resp.status) {
            setOrder(resp.order)
            setLoading(false);
        }
    }

    useEffect(() => {
        if (!order) return
        const groups = {};
        order.ordered_items.forEach((item) => {
            const key = `${item.deliveryDate}|${item.deliverySlot}|${item.pincode}|${item.shipping_address_id}`;
            if (!groups[key]) {
                groups[key] = {
                    deliveryDate: item.deliveryDate,
                    deliverySlot: item.deliverySlot,
                    pincode: item.pincode,
                    shipping_address: item.shipping_address,
                    items: []
                };
            }
            groups[key].items.push(item);
        });
        setGroupedItems(Object.values(groups));
    }, [order]);

    useEffect(() => {
        getOrder(orderid)
    }, [orderid])


    const generateInvoice = async (order_number) => {
        setInvoiceLoading(true);
        try {
            const resp = await GetOrders.generateOrderInvoice(order_number);
            if (resp && resp.status && resp.downloadUrl) {
                const response = await fetch(resp.downloadUrl);
                const blob = await response.blob();
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = `invoice_${order_number}.pdf`;
                document.body.appendChild(link);
                link.click();
                window.URL.revokeObjectURL(url);
                document.body.removeChild(link);
                getOrder(orderid)
            } else {
                console.error('Invalid response or download URL');
                alert('Failed to download invoice: Invalid response');
            }
        } catch (error) {
            console.error('Error downloading invoice:', error);
            alert('Error downloading invoice');
        } finally {
            setInvoiceLoading(false);
        }
    };

    const directDownload = async (order_number, fileUrl) => {
        setInvoiceLoading(true);
        try {
            const response = await fetch(fileUrl);
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `invoice_${order_number}.pdf`;
            document.body.appendChild(link);
            link.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(link);
            getOrder(orderid)
        } catch (error) {
            console.error('Error downloading invoice:', error);
            alert('Error downloading invoice');
        } finally {
            setInvoiceLoading(false);
        }
    };

    const reactToPrintFn = useReactToPrint({ contentRef });

    const orderStatusOptions = [
        {
            value: "created",
            label: "Created",
        },
        {
            value: "pending",
            label: "Pending",
        },
        {
            value: "confirmed",
            label: "Confirmed",
        },
        {
            value: "processing",
            label: "Processing",
        },
        {
            value: "shipped",
            label: "Shipped",
        },
        {
            value: "out_for_delivery",
            label: "Out for delivery",
        },
        {
            value: "delivered",
            label: "Delivered",
        },
        {
            value: "cancelled",
            label: "Cancelled",
        },
        {
            value: "returned",
            label: "Returned",
        }, 
        {
            value: "payment_failed",
            label: "Payment Failed",
        }
        
    ];

    const shippingPartners = [
        "FedEx",
        "DHL",
        "BlueDart",
        "DTDC",
        "Delhivery",
        "Ecom Express",
        "India Post",
    ];

    const validationSchema = Yup.object({
        // tracking_id: Yup.string().required("Tracking ID is required"),
        // shipping_partner: Yup.string().required("Please select a shipping partner"),
        order_status: Yup.string().required("Please select an order status"),
        message: Yup.string().min(5, "Message should be at least 5 characters"),
    });
    const cancelValidationSchema = Yup.object({
        reason: Yup.string().min(5, "Reason message should be at least 5 characters"),
    });

    const onSubmit = async (values, { setSubmitting }) => {
        const resp = await GetOrders.processOrder(order.order_number, values);
        if (resp && resp.success) {
            Alerts.alertMessage(resp.data.message, 'top-center', 'success');
            setOrderProcess(false);
            getOrder(orderid)
        } else {
            Alerts.alertMessage('Something went wrong !', 'top-center', 'error');
        }
    }


    const handleOrderCancel = async (values, { setSubmitting }) => {
        const resp = await GetOrders.cancelOrder(order.order_number, values);
        console.log(resp);
        // if (resp && resp.success) {
        //     Alerts.alertMessage(resp.data.message, 'top-center', 'success');
        //     setCancel(false);
        //     getOrder(orderid)
        // } else {
        //     Alerts.alertMessage('Something went wrong !', 'top-center', 'error');
        // }
    }


    const handleOrderCancelApproval = async (order_status) => {
        const resp = await GetOrders.cancelOrderApproval(order.order_number, { order_status });
        if (resp && resp.success) {
            Alerts.alertMessage(resp.data.message, 'top-center', 'success');
            getOrder(orderid)
        } else {
            Alerts.alertMessage('Something went wrong !', 'top-center', 'error');
        }
    }


    const orderCancelationOptions = [
        {
            value: "Approved",
            bg: "bg-success",
        },
        {
            value: "Rejected",
            bg: "bg-danger",
        },
        {
            value: "Pending",
            bg: "bg-warning",
        }
    ];

    const getStatusClass = (status) => {
        const option = orderCancelationOptions.find(
            (opt) => opt.value.toLowerCase() === status.toLowerCase()
        );
        return option ? option.bg : "bg-secondary";
    };
    const isCOD = order?.payment?.payment_method === "cod";

    return (
        <div className='singleOrderWrapper' ref={contentRef}>
            {
                isLoading ? <div className='loader'>
                    <img src='/images/loader.gif' alt='loader' />
                </div> : 
                <div className='container-fluid'>
                    <div className='orderHeader'>
                        <Link to="/app/orders/view" className='goBack no-print'><FiChevronLeft /></Link>
                        <div className='orderHeaderLeft'>
                            <div className='orderStatus'>
                                <span className='orderNumber'>#{order.order_number}</span>
                                <div className={`badge ${paymentStatusMap[order.payment?.payment_status]?.class || ""}`}>
                                    {paymentStatusMap[order.payment?.payment_status]?.label || ""}
                                </div>

                                <div className={`badge ${orderStatusMap[order.order_status]?.class || ""}`}>
                                    {orderStatusMap[order.order_status]?.label || ""}
                                </div>
                            </div>

                            <div className='orderDate'>{getDateTime(order.createdAt)} from Wishours</div>
                        </div>
                        <div className='orderHeaderRight'>
                            <button type='button' className='btn btn-default btn-sm no-print' onClick={reactToPrintFn}><FaPrint /> Print</button>
                            {/* <button
                                type='button'
                                className='btn btn-default btn-sm no-print'
                                disabled={!["processing", "pending"].includes(order.order_status)}
                                onClick={() => setCancel(true)}><MdOutlineCancel /> Cancel</button>
                            {
                                <Link to={`/app/refund/${orderid}`} className={`btn btn-default btn-sm no-print ${order.payment_status === 'refunded' || order.order_status === "Refund_Initiated" ? 'disabled' : ''}`}><TbCreditCardRefund /> Refund</Link>
                            } */}

                        </div>
                    </div>
                    <div className='orderDetails' >
                        <div className='row'>
                            <div className='col-md-9'>
                                <Card style={{ marginTop: 30 }}>
                                    <Card.Header style={{ display: 'flex', alignItems: 'center', gap: 10, fontWeight: 500, fontSize: 18 }}>
                                        Ordered Product
                                        {/* <div className={`badge ${statusClasses[order.order_status] || ""}`}>{order.order_status}
                                        ({order.ordered_items?.length})
                                            
                                        </div> */}
                                    </Card.Header>
                                    <Card.Body>
                                        {/* <div className='deliveryBox'>
                                            <h5>Delivery Method</h5>
                                            {
                                                order.shipping_method && parse(order.shipping_method.shipping_rate.shipping_rate_label.preview_label)
                                            }
                                        </div> */}

                                        {
                                            groupedItems && groupedItems.length > 0 && groupedItems.map((group, j) => {
                                                return <div className='orderedProducts' key={j}>
                                                    <div className='orderedProductHeader mb-3'>
                                                        <TbTruckDelivery /> Delivered On {formatDate(group.deliveryDate)} | {group.deliverySlot} | {group.pincode}
                                                    </div>
                                                    <div className='orderedProductBody'>
                                                        {
                                                            group.items && group.items.length > 0 && group.items.map((item, i) => {
                                                                let imagePath = '';
                                                                let title = '';
                                                                let photoCakePrice = 0;
                                                                let heartShapePrice = 0;

                                                                if (!item.pro_sku) {
                                                                    const productDetail = item?.variation_product;
                                                                    imagePath = productDetail?.product?.variation_image
                                                                        ? (
                                                                            productDetail?.variation_galleries?.[0]?.media_file?.path ||
                                                                            productDetail?.product?.product_galleries?.[0]?.media_file?.path ||
                                                                            productDetail?.product?.product_thumbnail?.path
                                                                        )
                                                                        : (
                                                                            productDetail?.product?.product_galleries?.[0]?.media_file?.path ||
                                                                            productDetail?.product?.product_thumbnail?.path
                                                                        );

                                                                    title = productDetail?.variation_content?.title || productDetail?.product?.title;
                                                                    photoCakePrice = item.isPhotoCake ? parseFloat(productDetail?.photo_cake_price) * parseFloat(item?.quantity) : 0;

                                                                    heartShapePrice = item?.isHeartShape ? parseFloat(productDetail?.heart_shape_price) * parseFloat(item?.quantity) : 0;


                                                                } else {
                                                                    const productDetail = item?.product;
                                                                    imagePath = productDetail?.product_galleries?.[0]?.media_file?.path || productDetail?.product_thumbnail?.path;
                                                                    title = productDetail?.title;
                                                                    photoCakePrice = item.isHeartShape ? parseFloat(productDetail?.photo_cake_price) * parseFloat(item?.quantity) : 0;

                                                                    heartShapePrice = item?.isPhotoCake ? parseFloat(productDetail?.heart_shape_price) * parseFloat(item?.quantity) : 0;
                                                                }
                                                                return (
                                                                    <div className="orderItemCard">

                                                                        <div className="orderItemLeft">
                                                                            <img src={imagePath} alt="product" />
                                                                        </div>

                                                                        <div className="orderItemMiddle">
                                                                            <h4>{title}</h4>

                                                                            <span>SKU: {item.pro_sku || item.var_sku}</span>

                                                                            {item?.isEggless && <span><FaCircle /> Eggless</span>}

                                                                            {item?.isPhotoCake && (
                                                                                <span>
                                                                                    {/* <FaPhotoVideo /> */}
                                                                                    <a href={item?.photoCakeImage} target="_blank">View Photo</a>
                                                                                </span>
                                                                            )}

                                                                            {item?.isHeartShape && (
                                                                                <span><FaHeart /> Heart Shape</span>
                                                                            )}
                                                                        </div>

                                                                        <div className="orderItemRight">
                                                                            <div>Unit: ₹ {Number(item.unit_price)}</div>
                                                                            {item.isHeartShape && <div>Heart Shape: ₹ {Number(heartShapePrice)}</div>}
                                                                            {item.isPhotoCake && <div>Photo Cake: ₹ {Number(photoCakePrice)}</div>}
                                                                            <div>Qty: {item.quantity}</div>
                                                                            <div className="totalPrice">
                                                                                ₹ {parseFloat(item.total_price) + parseFloat(heartShapePrice) + parseFloat(photoCakePrice)}
                                                                            </div>
                                                                        </div>

                                                                    </div>
                                                                );



                                                            })
                                                        }
                                                    </div>
                                                    <div className="shippingAddress">
                                                        <h5> <MdLocationPin /> <span> Shipping Address</span></h5>
                                                        <p>{group?.shipping_address?.full_name}<br />
                                                            {group?.shipping_address?.email}</p>
                                                        <p>{[
                                                            group?.shipping_address?.address_line_1,
                                                            group?.shipping_address?.address_line_2,
                                                            group?.shipping_address?.address_line_3,
                                                            group?.shipping_address?.city,
                                                            group?.shipping_address?.state,
                                                            group?.shipping_address?.pin_code
                                                        ]
                                                            .filter(Boolean)
                                                            .join(", ")}</p>
                                                    </div>

                                                </div>
                                            })
                                        }


                                    </Card.Body>
                                    <Card.Footer>
                                        <div className='itemsActions'>
                                            <button className='btn btn-default btn-sm' onClick={() => generateInvoice(order.order_number)}>{invoiceLoading ? 'Generatting..' : 'Print Invoice'}</button>
                                            {/* <button className='btn btn-dark btn-sm' onClick={() => setOrderProcess(true)} disabled={order.payment_status === 'refunded' || !order.invoice_link} >Order Process</button> */}

                                            <button
                                                className="btn btn-dark btn-sm"
                                                onClick={() => setOrderProcess(true)}
                                                disabled={order.payment_status === 'refunded' || order.invoice_link === null}
                                                data-bs-toggle="tooltip"
                                                data-bs-placement="top"
                                                title={
                                                    order.payment_status === 'refunded'
                                                        ? 'Order already refunded'
                                                        : !order.invoice_link
                                                            ? 'Invoice link not available'
                                                            : 'Click to process order'
                                                }
                                            >
                                                Order Process
                                            </button>

                                        </div>
                                    </Card.Footer>
                                </Card>
                                <Card style={{ marginTop: 25, fontWeight: 500, marginBottom: 50 }}>
                                    <Card.Header style={{ fontSize: 18 }}>
                                        Order Summary
                                    </Card.Header>
                                    <Card.Body>
                                        <table className='table table-ft-15 table-ft-16'>
                                            <tbody>
                                                <tr>
                                                    <th style={{ width: '30%' }}>Sub Total</th>
                                                    <td style={{ width: '60%' }}>items {order.ordered_items.length}</td>
                                                    <td style={{ textAlign: 'right' }}>₹ {order.subtotal}</td>
                                                </tr>
                                                <tr>
                                                    <th>Shipping</th>
                                                    <td>{
                                                        order.shipping_method && parse(order.shipping_method.shipping_rate.shipping_rate_label.name)} </td>
                                                    <td style={{ textAlign: 'right' }}>₹ {order.delivery_charge}</td>
                                                </tr>
                                                {order?.promo_code && order?.promo_code_discount && <tr>
                                                    <th>Coupon Discount</th>
                                                    <td>{order?.promo_code}</td>
                                                    <td style={{ textAlign: 'right', color: 'red' }}>- ₹ {order.promo_code_discount}</td>
                                                </tr>}


                                                <tr>
                                                    <th colSpan={2}>Total</th>
                                                    <td style={{ textAlign: 'right' }}>₹ {order.total_amount}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </Card.Body>
                                    <Card.Footer>
                                        <div className='paidFooter'>
                                            <p><strong>Grand Total</strong></p>
                                            <p style={{ textAlign: 'right' }}>₹ {order.total_amount}</p>
                                        </div>
                                    </Card.Footer>
                                </Card>

                                {order.order_cancel_requests && order.order_cancel_requests.length > 0 && (
                                    <Card style={{ marginTop: 30 }}>
                                        <Card.Header style={{ fontSize: 18 }} className='d-flex align-items-center justify-content-between'>
                                            <h5>Order Cancelation Request</h5>
                                            <Dropdown>
                                                <Dropdown.Toggle className="dropdown-toogle btn-icon">
                                                    <TbAntennaBars1 />
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu className='dropdown-list'>
                                                    <Dropdown.Item as="button" className="dropdown-btn">
                                                        <ConfModal message={'Are you sure you want to approve this request!'} delId={'Approved'} labelText={'Approve'} isIcon={false} handleDelete={handleOrderCancelApproval} />
                                                    </Dropdown.Item>
                                                    <Dropdown.Item as="button" className="dropdown-btn">
                                                        <ConfModal message={'Are you sure you want to Reject this request!'} delId={'Rejected'} labelText={'Rejected'} isIcon={false} handleDelete={handleOrderCancelApproval} />
                                                    </Dropdown.Item>
                                                    <Dropdown.Item as="button" className="dropdown-btn">
                                                        <ConfModal message={'Are you sure you want to pending this request!'} delId={'Pending'} labelText={'Pending'} isIcon={false} handleDelete={handleOrderCancelApproval} />
                                                    </Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </Card.Header>
                                        <Card.Body>
                                            <div className="order-timelines">
                                                {order.order_cancel_requests.map((item, i) => (
                                                    <div key={item.id} className="timeline-item">
                                                        <h6 className={`mb-1 text-white p-1 rounded ${getStatusClass(item.status)}`} style={{ width: 'fit-content', fontSize: 12 }}>
                                                            {item.status}
                                                        </h6>
                                                        <div
                                                            className="text-muted small "
                                                            dangerouslySetInnerHTML={{ __html: item.reason }}
                                                        />
                                                        <div className="text-secondary small mb-2">
                                                            {new Date(item.createdAt).toLocaleString()}
                                                        </div>

                                                    </div>
                                                ))}

                                            </div>
                                        </Card.Body>
                                    </Card>
                                )}


                            </div>
                            <div className='col-md-3'>
                                <OrderNote note={order.order_note} order={order} getOrder={getOrder} />
                                <Card style={{ marginTop: 30 }}>
                                    <Card.Body>
                                        <div className="addressBox">
                                            <div className="addressHeader">
                                                <h6>{`Customer`}</h6>
                                            </div>
                                            <p>{order.user?.name}</p>
                                            <p>{order.ordered_items?.length} Items</p>
                                        </div>
                                        <div className="addressBox">
                                            <div className="addressHeader">
                                                <h6>{`Contact Information`}</h6>
                                                {/* <button>
                                                    <FaPencilAlt />
                                                </button> */}
                                            </div>
                                            <p>{order.user?.email}</p>
                                        </div>

                                    </Card.Body>
                                </Card>
                                <Card style={{ marginTop: 30 }}>
                                    <Card.Header style={{ fontSize: 18 }}>
                                        Sender Details
                                    </Card.Header>
                                    <Card.Body>
                                        <div className="addressBox">
                                            <p>{order?.sender_name}</p>
                                            <p>{order?.sender_email}</p>
                                            <p>{order?.sender_phone}</p>
                                            <p>{order?.sender_city}</p>
                                        </div>
                                    </Card.Body>
                                </Card>
                                {order.order_timelines && order.order_timelines.length > 0 && (
                                    <Card style={{ marginTop: 30 }}>
                                        <Card.Header style={{ fontSize: 18 }}>
                                            Order Timeline
                                        </Card.Header>
                                        <Card.Body>
                                            <div className="order-timelines">
                                                {order.order_timelines.map((item, i) => (
                                                    <div key={item.id} className="timeline-item d-flex">

                                                        <div className="me-3 d-flex flex-column align-items-center">
                                                            <div
                                                                className={`timeline-dot rounded-circle ${item.status === "cancelled" ? "bg-danger" : "bg-success"
                                                                    }`}
                                                                style={{ width: 15, height: 15 }}
                                                            ></div>
                                                            {i !== order.order_timelines.length - 1 && (
                                                                <div className="flex-grow-1 border-start border-2 mt-1"></div>
                                                            )}
                                                        </div>


                                                        <div>
                                                            <h6 className={`mb-1 ${orderCancelationOptions.includes}`}>{item.status}</h6>
                                                            <div
                                                                className="text-muted small "
                                                                dangerouslySetInnerHTML={{ __html: item.message }}
                                                            />
                                                            <div className="text-secondary small mb-2">
                                                                {new Date(item.createdAt).toLocaleString()}
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}

                                            </div>
                                        </Card.Body>
                                    </Card>
                                )}



                            </div>
                        </div>
                    </div>

                </div>
            }


            <ThemeModal show={isOrderProcess} handleHide={() => setOrderProcess(false)} title={'Order Process'}>
                {isCOD && (
                    <div className="alert alert-warning">
                        COD Order — Payment will be collected on delivery
                    </div>
                )}
                <Formik
                    enableReinitialize={true}
                    initialValues={{
                        tracking_id: order?.tracking_id || 'xxxxxx',
                        shipping_partner: order?.shipping_partner,
                        order_status: order?.order_status,
                        message: "",
                    }}
                    validationSchema={validationSchema}
                    onSubmit={onSubmit}
                >
                    {({ isSubmitting }) => (
                        <Form>
                            <div className="mb-3">
                                <label>Tracking ID</label>
                                <Field type="text" name="tracking_id" className="form-control" disabled={order?.order_status === 'Shipped' || order?.order_status === 'Out_for_delivery' || order?.order_status === 'Delivered'} />
                                <ErrorMessage
                                    name="tracking_id"
                                    component="div"
                                    className="text-danger"
                                />
                            </div>

                            <div className="mb-3">
                                <label>Shipping Partner</label>
                                <Field as="select" name="shipping_partner" className="form-control" disabled={order?.order_status === 'Shipped' || order?.order_status === 'Out_for_delivery' || order?.order_status === 'Delivered'}>
                                    <option value="">---Select----</option>
                                    {shippingPartners.map((partner, idx) => (
                                        <option key={idx} value={partner}>
                                            {partner}
                                        </option>
                                    ))}
                                </Field>
                                <ErrorMessage
                                    name="shipping_partner"
                                    component="div"
                                    className="text-danger"
                                />
                            </div>

                            <div className="mb-3">
                                <label>Order Status</label>
                                <Field as="select" name="order_status" className="form-control">
                                    <option value="">---Select----</option>
                                    {orderStatusOptions.map((status, idx) => (
                                        <option key={idx} value={status.value}>
                                            {status.label}
                                        </option>
                                    ))}
                                </Field>
                                <ErrorMessage
                                    name="order_status"
                                    component="div"
                                    className="text-danger"
                                />
                            </div>

                            <div className="mb-3">
                                <label>Message</label>
                                <Field
                                    as="textarea"
                                    name="message"
                                    className="form-control"
                                    rows="3"
                                />
                                <ErrorMessage
                                    name="message"
                                    component="div"
                                    className="text-danger"
                                />
                            </div>

                            <div className="text-center">
                                <button
                                    type="submit"
                                    className="btn btn-primary"
                                    disabled={isSubmitting}
                                >
                                    {isSubmitting ? "Submitting..." : "Submit"}
                                </button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </ThemeModal>

            <ThemeModal show={isCancel} handleHide={() => setCancel(false)} title={'Order Cancel'}>
                <Formik
                    enableReinitialize={true}
                    initialValues={{
                        reason: "",
                    }}
                    validationSchema={cancelValidationSchema}
                    onSubmit={handleOrderCancel}
                >
                    {({ isSubmitting }) => (
                        <Form>
                            <div className="mb-3">
                                <label>Reason</label>
                                <Field
                                    as="textarea"
                                    name="reason"
                                    className="form-control"
                                    rows="3"
                                />
                                <ErrorMessage
                                    name="reason"
                                    component="div"
                                    className="text-danger"
                                />
                            </div>

                            <div className="text-center">
                                <button
                                    type="submit"
                                    className="btn btn-primary"
                                    disabled={isSubmitting}
                                >
                                    {isSubmitting ? "Submitting..." : "Submit"}
                                </button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </ThemeModal>
        </div>
    )
}

export default SingleOrder;